import { io } from 'socket.io-client';

export const socket = io(import.meta.env.VITE_SOCKET_URL, {
	extraHeaders: {},
	path: import.meta.env.VITE_SOCKET_PATH,
	withCredentials: true,
	autoConnect: false,
	transports: ['websocket'],
});
